export default __webpack_public_path__ + "static/media/img-error-blue.60aad3ce.svg";